export const float = input => {
    if (typeof input === 'string' && /[^\d,.]/g.test(input[0] === '-' ? input.slice(1) : input)) {
        return null;
    } else {
        const safeInput = input === undefined || input === null ? '' : input;
        const parsed = parseFloat(safeInput.toString().replace(/,/g, ''));
        const firstDotIndex = `${safeInput}`.indexOf('.');
        const lastDotIndex = `${safeInput}`.lastIndexOf('.');

        const hasMultipleDots = firstDotIndex !== lastDotIndex;
        return isNaN(parsed) || hasMultipleDots ? null : parsed;
    }
};

export const int = (input = '') => {
    const parsedAsFloat = float(input);
    return parsedAsFloat === null ? null : Math.round(parsedAsFloat);
};
